/*
This file is located in the main branch
Last time the file was updated (UTC): [05.06.2024 10:41:27]
Permissions to update outside the main branch: [true]
*/

import { enUS, ru, uz } from 'date-fns/locale';
import { Dictionary } from 'lodash';

const locales: Dictionary<Locale> = {
    en: enUS,
    ru: ru,
    uz: uz,
};

export default locales;
